import { EXEC_MODE } from "cfg";
import React from "react";


const logAnalyticData = ({ event, siteSection, pageName, server, website } : any, userData: any = {}) => {
    (window as any)['adobeDataLayer'] = (window as any)['adobeDataLayer'] || [];
    (window as any)['adobeDataLayer'].push({
        "event":event,
        "pageInfo": {
            "siteSection":siteSection,
            "pageName":pageName,
            "server":server,
            "website":EXEC_MODE,
        },
        "userInfo": {
            benefitLevel:sessionStorage.getItem('BenefitLevel'),
            customerID:sessionStorage.getItem('OWNER_NUMBER'),
            ...userData

        },
    });
};

const logLinkInfoAnalyticData = ({ event, siteSection, pageName, server, website, linkClickPage, linkClickRegion, linkName } : any) => {
    (window as any)['adobeDataLayer'] = (window as any)['adobeDataLayer'] || [];
    (window as any)['adobeDataLayer'].push({
        "event":event,
        "pageInfo": {
            "siteSection":siteSection,
            "pageName":pageName,
            "server":server,
            "website":EXEC_MODE,
        },
        "linkInfo": {
            "linkClickPage":linkClickPage,
            "linkClickRegion":linkClickRegion,
            "linkName":linkName
        }
    });
};

const trackAnalyticData = (name: string) => {
    (window as any)['_satellite'] && (window as any)['_satellite'].track(name);
}

export { logAnalyticData, trackAnalyticData, logLinkInfoAnalyticData };